import React from "react";
import { Logo } from "@/components/Logo";

export const Navbar = () => {
  const links = [
    { label: "Por qué Elecars", href: "#por-que-elecars" },
    { label: "200 puntos", href: "#inspeccion" },
    { label: "Proceso", href: "#proceso" },
    { label: "Vehículos", href: "#vehiculos" },
    { label: "FAQ", href: "#faq" },
  ];

  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50 bg-black/60 backdrop-blur-xl border-b border-white/5"
      data-testid="main-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 py-4 flex items-center justify-between">
        <a href="#hero" data-testid="logo-link">
          <Logo size="sm" />
        </a>

        <div className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.href.replace("#", "")}`}
              className="text-sm tracking-wide text-[#A3A3A3] hover:text-[#D4AF37] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </div>

        <a
          href="#contacto"
          data-testid="nav-cta-button"
          className="text-xs sm:text-sm uppercase tracking-[0.2em] bg-[#D4AF37] text-black px-5 py-2.5 hover:bg-[#E5C158] transition-colors"
        >
          Solicitar asesoramiento
        </a>
      </div>
    </nav>
  );
};

export default Navbar;
